import React from "react";
import { CodedProperty, DragAndDrop, DragAndDropItem, ensure, NamedProperty } from "sprint-common-web";

import { useCreateOrder } from "../common/provider/useCreateOrder";

interface OrderSubtitlesSequencerProps {
    label: string;
}

export const OrderSubtitlesSequencer: React.FC<OrderSubtitlesSequencerProps> = ({ label }) => {
    const { muxSpecification, dynamicSubtitles, setDynamicSubtitles } = useCreateOrder();
    const reindexSubtitles = (reorderedElements: DragAndDropItem[]) => {
        const newSubtitles = reorderedElements.map<CodedProperty>((element, index) => {
            const subtitle = dynamicSubtitles.find((item) => item.id === element.key);
            ensure(subtitle);

            return { ...subtitle, index: index + 1 };
        });

        setDynamicSubtitles(newSubtitles);
    };

    if (!muxSpecification?.isSequentialForSubtitles || dynamicSubtitles.length < 2) {
        return <></>;
    }

    return (
        <DragAndDrop
            label={label}
            items={dynamicSubtitles.map((item) => mapToDragAndDropItem(item))}
            onDrop={reindexSubtitles}
        />
    );
};

const mapToDragAndDropItem = (item: NamedProperty): DragAndDropItem => {
    return { key: item.id, text: item.name };
};
